import { useState } from "react";
import {CardHeader,Dropdown,DropdownItem,DropdownMenu,DropdownToggle,} from "reactstrap";
import { CommonHeaderWithDropDownPropsType } from "../../../../../Type/WidgetsType";
import { H3 } from "../../../../../AbstractElements";

const CommonHeaderWithDropDown = ({heading,dropDownList,headerClassName,headingClassName,caret,dropDownClass,dropDownIcon,dropDownToggleClassName}: CommonHeaderWithDropDownPropsType) => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(!open);
  };
  return (
    <CardHeader className={`card-no-border ${headerClassName ? headerClassName : ""}`}>
      <div className="header-top">
        <H3 className={headingClassName ? headingClassName : ""}>{heading}</H3>
        <div className={`${dropDownClass?dropDownClass:""}`}>
          <Dropdown isOpen={open} toggle={toggle}>
            <DropdownToggle className={dropDownToggleClassName?dropDownToggleClassName:""} color="transparent" caret={caret ? true : false} >
              {dropDownIcon ? <i className="icon-more-alt" /> :dropDownList[0]  }
            </DropdownToggle>
            <DropdownMenu end className="dropdown-menu-end">
              {dropDownList.map((item, index) => (
                <DropdownItem key={index}>{item}</DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </CardHeader>
  );
};

export default CommonHeaderWithDropDown;
